export default __webpack_public_path__ + "static/textlist_home_1_img_1-3de70825d99090657d85a99e460631ce.png";